<div class="inventory-page">
  <div class="container-xxl inventory">
    <header class="inventory-head">
      <div>
        <h1>Inventario storico</h1>
        <p>Le schede del catalogo storico, raggruppate per categoria.</p>
      </div>
    </header>

    <form class="inventory-filters" (submit)="$event.preventDefault(); applyFilters()">
      <div class="filters-head">
        <h2>Filtri</h2>
        <button class="filters-reset" type="button" (click)="resetFilters()">Azzera</button>
      </div>

      <div class="filters-grid">
        <div class="field-block">
          <label for="categoryFilter">Categoria</label>
          <select id="categoryFilter" class="field" [formControl]="categoryFilter" (change)="getSubcategories()">
            <option [ngValue]="null">Tutte le categorie</option>
            @for (category of categories; track category.id) {
              <option [ngValue]="category.id">{{ category.title }}</option>
            }
          </select>
        </div>

        <div class="field-block">
          <label for="subcategoryFilter">Sottocategoria</label>
          <select id="subcategoryFilter" class="field" [formControl]="subcategoryFilter">
            <option [ngValue]="null">Tutte le sottocategorie</option>
            @for (subcategory of subcategories; track subcategory.id) {
              <option [ngValue]="subcategory.id">{{ subcategory.title }}</option>
            }
          </select>
        </div>

        @if (showPlacement) {
          <div class="field-block">
            <label for="rackFilter">Scaffale</label>
            <input id="rackFilter" class="field" type="text" [formControl]="rackFilter">
          </div>
          <div class="field-block">
            <label for="shelfFilter">Ripiano</label>
            <input id="shelfFilter" class="field" type="text" [formControl]="shelfFilter">
          </div>
          <div class="field-block">
            <label for="caseFilter">Contenitore</label>
            <input id="caseFilter" class="field" type="text" [formControl]="caseFilter">
          </div>
        }
      </div>

      <div class="filters-actions">
        <button class="filters-submit" type="submit">Filtra</button>
      </div>
    </form>

    @if (inventoryHistorical.length > 0) {
      <p class="inventory-stats">
        <span><strong>{{ totalArticles }}</strong> {{ totalArticles === 1 ? 'scheda' : 'schede' }}</span>
        <span><strong>{{ inventoryHistorical.length }}</strong> {{ inventoryHistorical.length === 1 ? 'categoria' : 'categorie' }}</span>
      </p>

      <div class="inventory-groups">
        @for (group of inventoryHistorical; track group.title) {
          <section class="inventory-group">
            <button class="group-toggle" type="button" [disabled]="group.listArticles.length === 0"
              [attr.aria-expanded]="group.listArticles.length ? group.isOpen : null" (click)="toggleGroup(group)">
              <i class="bi" [class.bi-folder2-open]="group.isOpen" [class.bi-folder]="!group.isOpen" aria-hidden="true"></i>
              <span class="group-title">{{ group.title }}</span>
              <span class="group-count">{{ group.listArticles.length }}</span>
              @if (group.listArticles.length) {
                <i class="bi group-chevron" [class.bi-chevron-up]="group.isOpen" [class.bi-chevron-down]="!group.isOpen"
                  aria-hidden="true"></i>
              }
            </button>

            <div class="group-panel" [class.is-open]="group.isOpen" [attr.inert]="group.isOpen ? null : ''">
              <div class="group-panel-inner">
                @for (article of group.listArticles; track article.id) {
                  <button class="inventory-item" type="button" (click)="goToArticle(article.id)">
                    <span class="item-main">
                      <span class="item-title">{{ article.title }}</span>
                      @if (article.subcategory) {
                        <span class="item-sub">{{ article.subcategory }}</span>
                      }
                    </span>
                    @if (showPlacement) {
                      @let facts = placement(article);
                      @if (facts.length) {
                        <span class="item-facts">
                          @for (fact of facts; track fact.label) {
                            <span><span class="fact-label">{{ fact.label }}</span> {{ fact.value }}</span>
                          }
                        </span>
                      }
                    }
                  </button>
                }
              </div>
            </div>
          </section>
        }
      </div>
    } @else if (hasLoaded) {
      <p class="inventory-empty">La ricerca non ha prodotto risultati.</p>
    }
  </div>
</div>
